import { render, staticRenderFns } from "./PublicationDetail.vue?vue&type=template&id=239f4c54&scoped=true&"
import script from "./PublicationDetail.vue?vue&type=script&lang=ts&"
export * from "./PublicationDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239f4c54",
  null
  
)

export default component.exports